import ReactMarkdown from 'react-markdown';
import classes from '../CMSMarkdownEditor.module.scss';

const Output = props => {
	return (
		<div className={classes['output__container']}>
			<ReactMarkdown>{props.md}</ReactMarkdown>
		</div>
	);
};

export default Output;
